'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TaboolaCustomHeader = require('./TaboolaCustomHeader');

var _TaboolaCustomHeader2 = _interopRequireDefault(_TaboolaCustomHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TaboolaCustomHeader2.default;